import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyD_QXm5Ry0OjqlbS0pYb7A9IXVCJXlPPEM",
  authDomain: "admin-dashboard-f27dc.firebaseapp.com",
  projectId: "admin-dashboard-f27dc",
  storageBucket: "admin-dashboard-f27dc.appspot.com",
  messagingSenderId: "223600151299",
  appId: "1:223600151299:web:dc551fffd97d2fe34df736",
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);
export const storage = getStorage(app);
export const auth = getAuth();
